'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var buildSearchParams = require('../http/build-search-params.js');
var getCdnFromS3Url_util = require('./utils/get-cdn-from-s3-url.util.js');
var getCdnUrl_util = require('./utils/get-cdn-url.util.js');
var twicpicsTransformations_util = require('./utils/twicpics-transformations.util.js');

const imgixTransformationQueries = ({ fit, width, height, quality, compress = true, devicePixelRatio, }) => {
    const params = {
        auto: compress ? 'compress,format' : undefined,
        fit: fit === 'crop' ? 'crop' : undefined,
        dpr: Number.isFinite(devicePixelRatio) ? devicePixelRatio : undefined,
        h: Number.isFinite(height) ? height : undefined,
        w: Number.isFinite(width) ? width : undefined,
        q: quality !== undefined && quality >= 0 && quality <= 100 ? quality : undefined,
    };
    const searchParams = buildSearchParams.buildSearchParams(params).toString();
    return searchParams ? `${searchParams}` : '';
};
const twicpicsTransformationQueries = (params) => {
    const quality = params.quality || 70;
    const transformations = [['quality', quality]];
    const dpr = params.devicePixelRatio || 1;
    const width = params.width ? Math.round(params.width * dpr) : '-';
    const height = params.height ? Math.round(params.height * dpr) : '-';
    const fit = params.fit || 'cover';
    if (params.width !== undefined || params.height !== undefined) {
        transformations.push([fit, `${width}x${height}`]);
    }
    if (params.output !== undefined) {
        transformations.push(['output', params.output]);
    }
    return twicpicsTransformations_util.twicpicsTransformationChainToString(transformations);
};
/**
 *
 * @param type cdn provider: 'twicpics' | 'imgix'
 * @param domain provider domain
 * @param instanceMapper domain + the result of the instanceMapper will form the base path
 * @param cacheVersion
 * @returns \{ getCdnUrl, transformationQueries \}
 */
const createCdn = ({ type, domain, instanceMapper, cacheVersion }) => {
    const getCdnUrl = getCdnUrl_util.getCdnUrlFactory({
        domain,
        instanceMapper,
        transformationQueries: type === 'imgix' ? imgixTransformationQueries : twicpicsTransformationQueries,
        cacheVersion,
    });
    return {
        getCdnUrl,
        getCdnFromS3Url: getCdnFromS3Url_util.getCdnFromS3UrlFactory({
            getCdnUrl,
        }),
    };
};

exports.createCdn = createCdn;
exports.imgixTransformationQueries = imgixTransformationQueries;
exports.twicpicsTransformationQueries = twicpicsTransformationQueries;
//# sourceMappingURL=cdn.factory.js.map
